import { SVGProps } from "react";

const CustomerSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={58}
    height={58}
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 52C14 52 23.1291 52.5 29 52.5C34.8709 52.5 44 52 44 52"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.2487 4.83398H21.7487C9.66537 4.83398 4.83203 9.66732 4.83203 21.7507V36.2507C4.83203 45.3857 7.42545 50.1392 13.9988 52C14.5304 45.7167 21.1445 41.0114 28.9987 41.0114C36.8529 41.0114 43.4671 45.7167 43.9988 52C50.5721 50.1392 53.1654 45.3857 53.1654 36.2507V21.7507C53.1654 9.66732 48.332 4.83398 36.2487 4.83398ZM28.9987 34.2448C24.2137 34.2448 20.347 30.354 20.347 25.569C20.347 20.784 24.2137 16.9173 28.9987 16.9173C33.7837 16.9173 37.6504 20.784 37.6504 25.569C37.6504 30.354 33.7837 34.2448 28.9987 34.2448Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CustomerSuccess;
